<template>
  <div class="selection">
    <dx-description-label v-if="$te(`${translationKeyPrefix}.description`)">
      {{ $t(`${translationKeyPrefix}.description`) }}
    </dx-description-label>
    <div v-if="config.asRadios">
      <dx-radio-buttons
        :id="config.id"
        :options="translatedOptions"
        :value="value"
        :error="translatedError"
        @change="update"
        @blur="onBlur"
      />
    </div>
    <div v-else>
      <dx-radio-check
        :id="config.id"
        :label="translatedLabel"
        :name="config.id"
        :checked="value"
        :value="value"
        :disabled="config.readonly"
        :error="translatedError"
        type="checkbox"
        @input="updateCheckbox"
        @blur="onBlur"
      />
    </div>
  </div>
</template>

<script>
import {
  DxRadioCheck,
  DxRadioButtons,
} from '@sumcumo/dextra-frontend-component-lib'
import DxDescriptionLabel from '~/components/DX-DescriptionLabel/DxDescriptionLabel'

export default {
  name: 'DxBooleanAdapter',
  components: {
    DxDescriptionLabel,
    DxRadioButtons,
    DxRadioCheck,
  },
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    translatedOptions() {
      return [
        {
          value: true,
          name: this.$t('yes'),
        },
        {
          value: false,
          name: this.$t('no'),
        },
      ]
    },
    translationKeyPrefix() {
      if (this.config.source) {
        if (this.config.source.kind === 'values') {
          return `attributes.${this.config.source.key}.${this.config.source.originalId}`
        }

        return `${this.config.source.key}.${this.config.source.originalId}`
      }

      return ''
    },

    translatedLabel() {
      return this.$t(`${this.translationKeyPrefix}.label`)
    },

    translatedError() {
      if (!this.error) {
        return null
      }

      const errorOverrideKey = `${this.translationKeyPrefix}.error`
      if (this.$te(errorOverrideKey)) {
        return this.$t(errorOverrideKey)
      }

      return this.$t(`errors.boolean.${this.error.type}`, {
        ...this.error.params,
        label: this.translatedLabel,
      })
    },
  },
  methods: {
    update(newValue) {
      this.$emit('input', newValue)
    },
    updateCheckbox(newValue) {
      this.$emit('input', !newValue)
    },
    onBlur() {
      this.$emit('validate', this.config.id)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/variables/colors';
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/variables/typo';
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/functions/px-to-rem';

.selection {
  ::v-deep {
    .cmp-checkbox::after {
      border-color: $color-turquoise-surf !important;
    }
    .button {
      display: flex;
      border-color: $color-turquoise-surf;
      justify-content: center;
      align-items: center;
      background: $white-clr;
    }
    .radioInput ~ .text {
      border: 1px solid $color-turquoise-surf;
      border-radius: rem(20);
      padding: rem(12) rem(16);
      min-width: rem(96);
      background: $white-clr;
      color: $color-turquoise-surf;
      line-height: 1;
    }
    .buttonChecked,
    .button:hover,
    .button:active,
    .button:focus {
      .text {
        background: $color-turquoise-surf;
        color: $white-clr;
      }
    }
  }
}
</style>
